import { useQuery } from "@tanstack/react-query";
import { getCheckAuthenticated } from "api/app/fetch_check_authenicated";

export const useCheckAuthenticated = () => {
  return useQuery({
    queryKey: ['is_authicated'],
    queryFn: () => getCheckAuthenticated(),
  });
};
